import React from 'react';
import ExtReactDOM from '@sencha/ext-react-modern';
import './css/index.css';
import html2canvas from 'html2canvas';
import * as f from './common/Funcs';
import * as serviceWorker from './serviceWorker';
import AppViewPort from "./AppViewPort";
import Logger from './common/Logger';

window.html2canvas = html2canvas;

// Глобальная обработка ошибок JavaScript
window.onerror = (message, source, lineno, colno, error) => {
    const errorInfo = {
        message: message,
        source: source,
        lineno: lineno,
        colno: colno,
        error: error?.toString(),
        stack: error?.stack
    };
    
    Logger.error(`Global JavaScript Error: ${message}`);
    Logger.error(`Source: ${source}:${lineno}:${colno}`);
    if (error?.stack) {
        Logger.error(`Stack: ${error.stack}`);
    }
    
    // Также выводим в консоль
    console.error('Global error:', errorInfo);
    
    // Возвращаем false, чтобы ошибка также обрабатывалась браузером
    return false;
};

// Глобальная обработка необработанных промисов
window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    
    // Игнорируем AbortError - это нормальная отмена запросов через AbortController
    if (reason?.name === 'AbortError' || reason?.message?.includes('aborted')) {
        return;
    }
    
    const errorMessage = reason?.message || reason?.toString() || 'Unhandled promise rejection';
    const errorStack = reason?.stack || 'No stack trace';
    
    Logger.error(`Unhandled Promise Rejection: ${errorMessage}`);
    if (errorStack !== 'No stack trace') {
        Logger.error(`Stack: ${errorStack}`);
    }
    Logger.error(`Reason: ${JSON.stringify(reason)}`);
    
    // Также выводим в консоль
    console.error('Unhandled promise rejection:', event.reason);
    
    // Предотвращаем вывод ошибки в консоль браузера по умолчанию (опционально)
    // event.preventDefault();
});

// Перехват ошибок в fetch запросах (через глобальный обработчик)
const originalFetch = window.fetch;
window.fetch = async function(...args) {
    try {
        const response = await originalFetch.apply(this, args);
        
        // Логируем ошибки HTTP (4xx, 5xx)
        if (!response.ok) {
            const url = args[0]?.toString() || 'Unknown URL';
            const status = response.status;
            const statusText = response.statusText;
            
            Logger.error(`HTTP Error: ${status} ${statusText} - ${url}`);
            
            // Пытаемся прочитать тело ответа для дополнительной информации
            try {
                const clonedResponse = response.clone();
                const text = await clonedResponse.text();
                if (text) {
                    Logger.error(`Response body: ${text.substring(0, 500)}`);
                }
            } catch (e) {
                // Игнорируем ошибки при чтении тела ответа
            }
        }
        
        return response;
    } catch (error) {
        // Игнорируем AbortError - это нормальная отмена запросов через AbortController
        if (error?.name === 'AbortError' || error?.message?.includes('aborted')) {
            throw error;
        }
        
        const url = args[0]?.toString() || 'Unknown URL';
        if (url.toLowerCase().indexOf('logger')) return;
        Logger.error(`Fetch Error: ${error?.message || error?.toString() || 'Unknown error'} - ${url}`);
        if (error?.stack) {
            Logger.error(`Stack: ${error.stack}`);
        }
        throw error;
    }
};

//error
const blocks = ['error', 'warn', 'log', 'debug'];
//перехват изменения размера
window.onresize = () => (window.IasLoApp) ? window.IasLoApp.forceUpdate() : null;
//перехват нажатия ctrl+alt+e
document.addEventListener('keyup', (event) => {
    if (event.altKey == true &&
        event.ctrlKey == true &&
        event.keyCode == 69) {
        html2canvas(document.body).then((canvas) => {
            const dataPng = canvas.toDataURL('image/png');
            //.replace(/data:image\/png;base64,/, '');
            f.saveFile({blobFile: dataPng, fileName: 'error', fileType: 'png'});
            let content = {};
            blocks.map(b => {
                content[b] = console[`${b}s`]
            });
            content['cookies'] = document.cookie;
            const replacerFunc = () => {
                const visited = new WeakSet();
                return (key, value) => {
                    if (typeof value == "object" && value !== null) {
                        if (visited.has(value)) {
                            return;
                        }
                        visited.add(value);
                    }
                    return value;
                };
            };
            const dataLog = 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify(content, replacerFunc(), 2));
            f.saveFile({blobFile: dataLog, fileName: 'iaslo', fileType: 'log'});
        });
    }
});
Object.defineProperty(String.prototype, 'firstToUpper', {
    __proto__: null,
    value: function () {
        if (this == null) {
            throw new TypeError('"this" is null or not defined');
        }
        return this.charAt(0).toUpperCase() + this.slice(1);
    },
    configurable: true
});
Object.defineProperty(String.prototype, 'firstToLower', {
    __proto__: null,
    value: function () {
        if (this == null) {
            throw new TypeError('"this" is null or not defined');
        }
        return this.charAt(0).toLowerCase() + this.slice(1);
    },
    configurable: true
});
Object.defineProperty(HTMLCollection.prototype, 'getArray', {
    __proto__: null,
    value: function () {
        if (this == null) {
            return [];
        }
        var result = Array.prototype.slice.apply(this);
        return result;
    },
    configurable: true
});

ExtReactDOM.render(<AppViewPort
    id={'iasViewPort'}
    ref={(port => {
        window.IasLoApp = port;
    })}/>, document.getElementById('root'));

serviceWorker.unregister();

let baseColor = '#024059';
document.documentElement.style.setProperty("--base-color", baseColor);
